import React from 'react';
import SearchFilterFields from '@/components/SearchFilterFields';
import SourceFieldset from '@/features/quickSetup/SourceFieldset';
import TemplateSelector from '@/features/quickSetup/TemplateSelector';
import WizardFormLayout from '@/features/quickSetup/WizardFormLayout';
import type { QuickSetupFormState } from '@/features/quickSetup/types';
import {
  quickSetupToVehicleAdminForm,
  vehicleAdminPatchToQuickSetup,
} from '@/features/quickSetup/vehicleFilters';
import type { Source } from '@/types';

type Props = {
  form: QuickSetupFormState;
  sources: Source[];
  onChange: (patch: Partial<QuickSetupFormState>) => void;
  onToggleSource: (name: string) => void;
  onSetSourceNames?: (names: string[]) => void;
  sourcesEmptyHint?: string;
};

export default function VehicleWizard({
  form,
  sources,
  onChange,
  onToggleSource,
  onSetSourceNames,
  sourcesEmptyHint,
}: Props) {
  const adminForm = quickSetupToVehicleAdminForm(form);

  return (
    <WizardFormLayout
      aside={
        <>
          <TemplateSelector category="vehicles" form={form} onApply={onChange} />
          <SourceFieldset
            sources={sources}
            selected={form.source_names}
            onToggle={onToggleSource}
            onSetSelected={onSetSourceNames}
            emptyHint={sourcesEmptyHint}
          />
        </>
      }
    >
      <SearchFilterFields
        variant="wizard"
        category="vehicles"
        form={adminForm}
        onChange={(next) => onChange(vehicleAdminPatchToQuickSetup(next))}
      />
    </WizardFormLayout>
  );
}
